const PROFILE_PRESETS = {
  easy: {
    reactionDelayMs: 430,
    predictionBounces: 0,
    errorMargin: 42,
    deadzone: 18,
  },
  normal: {
    reactionDelayMs: 320,
    predictionBounces: 0,
    errorMargin: 30,
    deadzone: 14,
  },
  hard: {
    reactionDelayMs: 190,
    predictionBounces: 1,
    errorMargin: 12,
    deadzone: 8,
  },
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value))
}

function resolveProfile(profileName) {
  if (profileName && PROFILE_PRESETS[profileName]) {
    return PROFILE_PRESETS[profileName]
  }
  return PROFILE_PRESETS.normal
}

class BotAI {
  constructor(paddleSide, profileName = 'normal') {
    this.paddleSide = paddleSide
    this.profileName = profileName
    this.profile = resolveProfile(profileName)
    this.lastPerceptionAt = 0
    this.perceived = null
    this.targetY = null
    this.errorOffset = 0
  }

  setProfile(profileName = 'normal') {
    this.profileName = profileName
    this.profile = resolveProfile(profileName)
  }

  update(snapshot) {
    const now = Date.now()
    if (!this.perceived || (now - this.lastPerceptionAt) >= this.profile.reactionDelayMs) {
      this.lastPerceptionAt = now
      this.perceived = {
        x: snapshot.ball.x,
        y: snapshot.ball.y,
        vx: snapshot.ball.vx,
        vy: snapshot.ball.vy,
      }
      this.targetY = this.predictTargetY(snapshot)
      this.errorOffset = (Math.random() * 2 - 1) * this.profile.errorMargin
    }

    const desiredY = clamp(
      (this.targetY || snapshot.bounds.centerY) + this.errorOffset,
      snapshot.bounds.top,
      snapshot.bounds.bottom,
    )
    const diff = desiredY - snapshot.paddle.y
    if (Math.abs(diff) <= this.profile.deadzone) {
      return 'neutral'
    }
    return diff > 0 ? 'down' : 'up'
  }

  predictTargetY(snapshot) {
    const perceived = this.perceived
    if (!perceived) {
      return snapshot.bounds.centerY
    }

    if (this.paddleSide === 'left' && perceived.vx >= 0) {
      return snapshot.bounds.centerY
    }
    if (this.paddleSide === 'right' && perceived.vx <= 0) {
      return snapshot.bounds.centerY
    }

    const paddleX = snapshot.paddle.x
    const ballRadius = snapshot.ball.radius
    let simX = perceived.x
    let simY = perceived.y
    let simVX = perceived.vx
    let simVY = perceived.vy
    let bouncesLeft = this.profile.predictionBounces
    const maxSteps = 600
    const step = 1 / 60

    for (let i = 0; i < maxSteps; i++) {
      simX += simVX * step
      simY += simVY * step

      if (simY - ballRadius <= snapshot.bounds.top) {
        simY = snapshot.bounds.top + ballRadius
        simVY = -simVY
        bouncesLeft -= 1
      } else if (simY + ballRadius >= snapshot.bounds.bottom) {
        simY = snapshot.bounds.bottom - ballRadius
        simVY = -simVY
        bouncesLeft -= 1
      }

      if (bouncesLeft < 0) {
        break
      }

      if (this.paddleSide === 'left' && simX <= paddleX) {
        return simY
      }
      if (this.paddleSide === 'right' && simX >= paddleX) {
        return simY
      }
    }

    return simY
  }
}

export { PROFILE_PRESETS }
export default BotAI
